// Load css file
const loadCss = (fileName) => {
  return new Promise((resolve, reject) => {
    const link = document.createElement('link');
    const fileId = `${fileName.toUpperCase()?.replace('-', '')}CSS`;
    const mainPath = document.getElementById('MainCssPath').href;
    link.onload = resolve;
    link.onerror = reject;
    link.id = fileId;
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = mainPath.includes('?v')
      ? mainPath.split('?v')[0]?.replace('/assets/main.css', `/assets/${fileName}.css`)
      : mainPath.replace('/assets/main.css', `/assets/${fileName}.css`);
    link.media = 'all';
    if (!document.getElementById(fileId)) {
      document.head.appendChild(link);
    }
  });
};
// Load js file
const loadScript = (fileName) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    const fileId = `${fileName.toUpperCase()?.replace('-', '')}JS`;
    const mainPath = document.getElementById('MainJsPath').src;
    script.onload = resolve;
    script.onerror = reject;
    script.async = true;
    script.id = fileId;
    script.type = 'text/javascript';
    script.src = mainPath.includes('?v')
      ? mainPath.split('?v')[0]?.replace('/assets/main.js', `/assets/${fileName}.js`)
      : mainPath.replace('/assets/main.js', `/assets/${fileName}.js`);
    if (!document.getElementById(fileId)) {
      document.head.appendChild(script);
    }
  });
};
// Scroll animation observer
const scrollAnimationObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('scroll-animation--active');
        scrollAnimationObserver.unobserve(entry.target);
      }
    });
  },
  {
    threshold: 0.25,
  }
);

(function scrollAnimationInit() {
  if (!document.documentElement.classList.contains('js-animations--accent')) return;

  document.querySelectorAll('.scroll-animation').forEach((el, i) => {
    scrollAnimationObserver.observe(el);
  });
})();
// Add helper class when announcement bar is enabled
window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.announcement-bar') != null) {
    document.body.classList.add('is-announcement-bar');
  }
});
// Helper functions
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .drawer, modal-dialog"
    )
  );
}
const trapFocusHandlers = {};
function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}
// Details animation
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.classList.remove('details--active');
  summaryElement.setAttribute('aria-expanded', false);
  setTimeout(() => {
    openDetailsElement.removeAttribute('open');
  }, 500);
  if (summaryElement.classList.contains('mmenu__hamburger') && document.body.classList.contains('mmenu--open')) {
    document.body.classList.remove('mmenu--open');
  }
  summaryElement.focus();
}
class Accordion {
  constructor(el) {
    this.details = el;
    this.summary = el.querySelector('summary');
    this.content = el.querySelector('.details__content');

    this.summary.addEventListener('click', (event) => this.onClick(event));
    this.details.addEventListener('keyup', onKeyUpEscape);
    window.addEventListener('DOMContentLoaded', this.mobileOnlyDetails());
    window.addEventListener('resize', () => {
      this.mobileOnlyDetails();
    });
  }

  onClick(event) {
    event.preventDefault();
    event.currentTarget.setAttribute('aria-expanded', !this.details.hasAttribute('open'));

    if (this.details.hasAttribute('open')) {
      this.collapse();
    } else {
      this.expand();
    }

    if (this.summary.classList.contains('mmenu__hamburger')) {
      document.body.classList.toggle('mmenu--open');
    }
  }

  collapse() {
    this.details.classList.remove('details--active');
    setTimeout(() => {
      this.details.removeAttribute('open');
    }, 500);
  }

  expand() {
    this.details.setAttribute('open', '');
    setTimeout(() => {
      this.details.classList.add('details--active');
    }, 250);
  }

  mobileOnlyDetails() {
    if (this.details.classList.contains('mobile--only')) {
      if (window.innerWidth < 769) {
				if(!this.details.classList.contains('dropdown--level-1')){
					this.collapse();
				}
      } else {
        this.expand();
      }
    }
  }
}
document.querySelectorAll('[id^="Details-"]').forEach((el) => {
  new Accordion(el);
});
// Check if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}
function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.onLoad();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

		this.updatePreorder();

    this.updateQuantity();

    this.stylestToggleAddButton3Options();
    this.stylestSoldOutOptions();
    this.stylestOption3Colors();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      //this.setUnavailable();
    } else {
      //this.updateMedia();
      this.updateURL();
      //this.updateVariantInput();
      //this.renderProductInfo();
      //this.updateShareUrl();
      //this.updateUnavailableVariants();
      //this.updateSelectedValues();
    }
  }

  onLoad() {
    this.updateUnavailableVariants();
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const variantImage = this.currentVariant.featured_media.preview_image.src;

    if (this.closest('.product-card')) {
      const media = this.closest('.product-card').querySelector('.product-card__media .media--primary');
      media.innerHTML = `<img src="${variantImage}&width=1440">`;
    } else {
      const carousel = document.querySelector('#main-carousel');
      if (!carousel) return;
      const media = carousel.querySelector(
        `.splide__slide[data-media-position="${this.currentVariant.featured_media.position}"]`
      );
      const mediaContainer = carousel.querySelector('.splide__list');

      if (carousel.classList.contains('is-active')) {
        var Slides = main.Components.Slides.filter('.product__media-item');

        if (Slides[this.currentVariant.featured_media.position]) {
          main.go(Slides[this.currentVariant.featured_media.position].index);
        }
      } else {
        media.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
      }
    }
  }

  updateURL() {
		console.log('updateURL')
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    const urlInput = shareButton.querySelector('input');
    let urlToShare = urlInput ? urlInput.value : document.location.href;
    const url = `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`;
    urlToShare = url;
    urlInput.value = url;
  }

  updateVariantInput() {
    if (this.closest('.product-card')) {
      if (this.closest('form')) {
        const productCardInput = this.closest('form').querySelector('input[name="id"]');
        productCardInput.value = this.currentVariant.id;
        productCardInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else {
      const productForms = document.querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
      );
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.style.display = 'block';
    } else {
      pickUpAvailability.style.display = 'none';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url.split('?')[0]}.json`)
      .then((response) => response.json())
      .then((data) => {
        const variant = data.product.variants.filter((v) => {
          return v.id === this.currentVariant.id;
        });

        const symbol = document.querySelectorAll('.price-item')[0].innerHTML.charAt(0);
        let currency = document.querySelectorAll('.price-item')[0].innerHTML.split(' ')[1];
        if (currency == undefined) currency = '';
        let price, compare_price, saleBadge;
        const soldOutBadge = document.querySelector('.product-wrapper .badge--sold');
        let compare_at_price = variant[0].compare_at_price;
        if (compare_at_price != '') {
          compare_at_price = symbol + variant[0].compare_at_price + ' ' + currency;
        }

        if (this.closest('.product-card')) {
          price = this.closest('.product-card').querySelector('.price-item--regular');
          compare_price = this.closest('.product-card').querySelector('.price-item--compare');
          saleBadge = this.closest('.product-card').querySelector('.badge--sale');
        } else {
          price = this.closest('.product__info').querySelector('.price-item--regular');
          compare_price = this.closest('.product__info').querySelector('.price-item--compare');
          saleBadge = this.closest('.product__info').querySelector('.badge--sale');
        }

        if (price.closest('.price').querySelector('.price-varies__label')) {
          price.closest('.price').querySelector('.price-varies__label').remove();
        }

        price.innerHTML = symbol + variant[0].price + ' ' + currency;

        if (compare_price) {
          compare_price.innerHTML = compare_at_price;
          if (compare_at_price != '') {
            if (saleBadge) saleBadge.classList.remove('visually-hidden');
          } else {
            if (saleBadge) saleBadge.classList.add('visually-hidden');
          }
        } else {
          if (compare_at_price != '') {
            const comparePriceNew = document.createElement('s');
            comparePriceNew.className += 'price-item price-item--compare';
            comparePriceNew.textContent = compare_at_price;

            const saleBadgeNew = document.createElement('span');
            saleBadgeNew.className += 'badge badge--sale';
            saleBadgeNew.textContent = 'Sale';

            price
              .closest('.price-item--regular')
              .parentNode.insertBefore(comparePriceNew, price.closest('.price-item--regular').nextSibling);

            if (!this.closest('.product-card')) {
              price.closest('.price-item--regular').parentNode.insertBefore(saleBadgeNew, comparePriceNew.nextSibling);
            }
          }
        }

        if (!this.closest('.product-card')) {
          if (!this.currentVariant.available) {
            if (soldOutBadge) {
              soldOutBadge.classList.remove('visually-hidden');
            } else {
              const soldOutBadgeNew = document.createElement('span');
              soldOutBadgeNew.className += 'badge badge--sold';
              soldOutBadgeNew.textContent = 'Sold Out';
              document
                .querySelector('.single-product--form')
                .closest('.product__info')
                .querySelector('.price')
                .append(soldOutBadgeNew);
            }
          } else {
            if (soldOutBadge) {
              soldOutBadge.classList.add('visually-hidden');
            }
          }
        }

        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    let productForm;

    if (this.closest('.product-card')) {
      productForm = this.closest('form');
    } else {
      productForm = document.querySelector(`.single-product--form`);
    }

    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    let productForm;
    if (this.closest('.product-card')) {
      productForm = this.closest('form');
    } else {
      productForm = document.querySelector(`.single-product--form`);
    }

    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (addButton) {
      addButtonText.textContent = window.variantStrings.unavailable;
    }

    if (addButton.hasAttribute('hidden')) {
      addButton.removeAttribute('hidden');
      setTimeout(() => addButton.setAttribute('hidden', ''), 3000);
    } else {
    }
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  getSelectedOption(i) {
    if (this.dataset.type == 'select') {
      return this.querySelectorAll('.product-form__input')[i].querySelector('select').value;
    } else {
      let selectedOption = null;
      this.querySelectorAll('.product-form__input')
        [i].querySelectorAll('input')
        .forEach((elm) => {
          if (elm.checked) selectedOption = elm.value;
        });
      return selectedOption;
    }
  }

  setDisabledOption(i, option) {
    const target = this.querySelectorAll('.product-form__input')[i].querySelector(`.variant-option[value="${option}"]`);
    if (target) {
      if (this.dataset.type == 'select') {
        target.setAttribute('disabled', '');
      } else {
        target.classList.add('sold-out');
      }
    }
  }
  resetDisabledOption(i) {
/*
    this.querySelectorAll('.product-form__input')
      [i].querySelectorAll('.variant-option')
      .forEach((elm) => {
        if (this.dataset.type == 'select') {
          elm.removeAttribute('disabled');
        } else {
          elm.classList.remove('sold-out');
        }
      });
  */
  }

  updateUnavailableVariants() {
    if (this.dataset.hideVariants == 'true') {
      let options1 = {},
        options2 = {},
        options3 = {},
        option1Selected = null,
        option2Selected = null;

      if (this.dataset.variants > 1) {
        option1Selected = this.getSelectedOption(0);
        this.resetDisabledOption(1);
      }
      if (this.dataset.variants > 2) {
        option2Selected = this.getSelectedOption(1);
        this.resetDisabledOption(2);
      }

      this.getVariantData().forEach((el) => {
        if (this.dataset.variants > 0) {
          if (!options1[el.option1]) {
            options1[el.option1] = [];
          }
          options1[el.option1].push(String(el.available));
        }
        if (this.dataset.variants > 1) {
          if (!options2[el.option2]) {
            options2[el.option2] = [];
          }
          options2[el.option2].push(String(el.available));
        }
        if (this.dataset.variants == 1) {
          if (!el.available) {
            this.setDisabledOption(0, el.option1);
          }
        }
        if (this.dataset.variants == 2) {
          if (el.option1 == option1Selected) {
            if (!el.available) this.setDisabledOption(1, el.option2);
          }
        }
        if (this.dataset.variants > 2) {
          if (!options3[el.option3]) {
            options3[el.option3] = [];
          }
          options3[el.option3].push(String(el.available));
          if (el.option2 == option2Selected && el.option1 == option1Selected && !el.available) {
            this.setDisabledOption(2, el.option3);
          }
        }
      });
    }
  }

	updatePreorder() {
		//console.log('update preorder');
	}

  updateSelectedValues() {
    if (this.dataset.variants > 2) {
      this.querySelectorAll('.product-form__input')[0].querySelector('#selectedOption').textContent =
        this.getSelectedOption(0);
      this.querySelectorAll('.product-form__input')[1].querySelector('#selectedOption').textContent =
        this.getSelectedOption(1);
      this.querySelectorAll('.product-form__input')[2].querySelector('#selectedOption').textContent =
        this.getSelectedOption(2);
    } else if (this.dataset.variants > 1) {
      this.querySelectorAll('.product-form__input')[0].querySelector('#selectedOption').textContent =
        this.getSelectedOption(0);
      this.querySelectorAll('.product-form__input')[1].querySelector('#selectedOption').textContent =
        this.getSelectedOption(1);
    } else {
      this.querySelector('.product-form__input').querySelector('#selectedOption').textContent =
        this.getSelectedOption(0);
    }
  }

  updateQuantity() {

    //console.log('update inventoryQuantity')
    let form = this.parentNode.getElementsByTagName('form')[0]
    let atcWrap = form.getElementsByClassName('js-product-main-btns')[0];
    if(form.getElementsByClassName('inventory-alert').length > 0){
      form.getElementsByClassName('inventory-alert')[0].remove();
    }
    let inventoryQuantity;
    Array.from(form.getElementsByTagName('select')[0].getElementsByTagName('option')).forEach(
      option => {
        if(option.hasAttribute('selected')){
          inventoryQuantity = option.dataset.quantity;
          console.log(option.dataset.quantity)
        }
      }
    )
    //console.log('inventoryQuantity')
    //console.log(inventoryQuantity)
    //if(inventoryQuantity < 6 && inventoryQuantity > 0) {
      //atcWrap.insertAdjacentHTML('beforebegin', `<div class="inventory-alert">Only ${inventoryQuantity} left</div>`)
      //setTimeout(()=>{
        //form.getElementsByClassName('inventory-alert')[0].classList.add('show');
      //}, 100)
    //}

  }

  stylestToggleAddButton3Options(){
    // only applies to products with 3 options. Example: color, size, bust
    if(this.dataset.variants < 3) return;
    let formEl = this.parentNode.querySelector('form');

    // Step 1 get active variant id
    let variantId = this.stylestGetActiveVariantId();

    if(!variantId) {
      formEl.querySelector('.product-size__btn').classList.add('is-hidden');
      formEl.querySelector('.product-size__btns-secondary').classList.remove('is-hidden');
      return;
    }

    //var variantId = selectedOption;
    //console.log('variantId', variantId)
    //console.log('this.dataset.variants',this.dataset)

    // Step 2 get list of available variants
    let variantArr = JSON.parse(this.getElementsByTagName('script')[0].innerText)


    // Step 3 get find active variant id in array
    let variantObj =  variantArr.find( v => variantId == v.id);

    //console.log('variantObj', variantObj)

    // Step 4 toggle atc button and bis button based on availability
    if(variantObj.available == true){
      formEl.querySelector('.product-size__btn').classList.remove('is-hidden');
      formEl.querySelector('.product-size__btns-secondary').classList.add('is-hidden');
    } else {
      formEl.querySelector('.product-size__btn').classList.add('is-hidden');
      formEl.querySelector('.product-size__btns-secondary').classList.remove('is-hidden');
    }
    //console.log('variantData',variantData)
 
  }
  stylestGetActiveVariantId() {

    let formEl = this.parentNode.querySelector('form');
    let secondOptionGroup = formEl.querySelectorAll("[data-option-group]")[1];
    //console.log('secondOptionGroup',secondOptionGroup)

    let active = secondOptionGroup.querySelector('.js-active-now')
    //console.log('active', active)
    let selectedOption = [...active.querySelectorAll('option')].find(optionEl => optionEl.selected);
    //console.log('selectedOption', selectedOption)

    if(!selectedOption) {
      return false
    } else {
      return selectedOption.dataset.variantId
    }
  }

  stylestSoldOutOptions(){
    // only applies to products with 3 options. Example: color, size, bust
    if(this.dataset.variants < 3) return;
    let formEl = this.parentNode.querySelector('form');

    // Step 1 get active variant id
    let variantId = this.stylestGetActiveVariantId();

    if(!variantId) {
      formEl.querySelector('.product-size__btn').classList.add('is-hidden');
      formEl.querySelector('.product-size__btns-secondary').classList.remove('is-hidden');
      return;
    }

    // Step 2 get list of available variants
    let variantArr = JSON.parse(this.getElementsByTagName('script')[0].innerText)


    // Step 3 get find active variant id in array
    let variantObj =  variantArr.find( v => variantId == v.id);

    //console.log('variantObj', variantObj)

    // reset sold out options
    this.querySelectorAll('label').forEach(label => {
      label.classList.remove('sold-out');
    })


    let selectedOption2 = variantObj.option2;
    let selectedOption3 = variantObj.option3;

    // step 4 add sold out class to options that are not available based on selected option 2 and option 3
    variantArr.forEach( v =>{
      if(v.option3 == selectedOption3 && v.available == false){
        this.querySelector(`label[data-option-value="${v.option2}"]`).classList.add('sold-out');
      }

      if(v.option2 == selectedOption2 && v.available == false){
        this.querySelector(`label[data-option-value="${v.option3}"]`).classList.add('sold-out');
      }
    })
  }

  stylestOption3Colors(){
    if(this.dataset.variants < 3) return;

    // Step 1 get active variant id
    let variantId = this.stylestGetActiveVariantId();

    // Step 2 get list of available variants
    let variantArr = JSON.parse(this.getElementsByTagName('script')[0].innerText)

    const option3Values = [...new Set(variantArr.map(v => v.option3))]; 

    let variantObj =  variantArr.find( v => variantId == v.id);

    const option3 = variantObj.option3.toLowerCase();

    const productTop = document.querySelector('.product-size__main');
    if(!productTop) return;
    const swatchArr = productTop.querySelectorAll('.product-top__color-link--new');
    swatchArr.forEach( a => {
      a.style.removeProperty('opacity');
      a.style.removeProperty('cursor');
      //a.style.removeProperty('pointer-events');
      if( option3 !== option3Values[0].toLowerCase() && !a.dataset.option3arr.toLowerCase().split(', ').some( opt => opt == option3) ){
        a.style.opacity = '0.35'
        a.style.cursor = 'default'
        //a.style.pointerEvents = 'none';
      }
    })
  }

}

customElements.define('variant-selects', VariantSelects);
class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}
customElements.define('variant-radios', VariantRadios);
class MainDrawer extends HTMLElement {
  constructor() {
    super();

    this.trigger = this.querySelector('.drawer__trigger');
    this.drawer = this.querySelector('.drawer');
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.closeDrawer());
    this.querySelectorAll('.drawer-close').forEach((el) => el.addEventListener('click', () => this.closeDrawer()));
    if (this.trigger) {
      this.trigger.addEventListener('click', () => this.openDrawer());
    }

    this.setFocus = debounce((event) => {
      trapFocus(this, this.querySelector('.drawer__container'));
    }, 300);
  }

  openDrawer() {
    this.setFocus();
    this.drawer.classList.add('drawer--active');
    document.body.classList.add('drawer--open');
  }

  closeDrawer() {
    this.drawer.classList.remove('drawer--active');
    setTimeout(() => {
      document.body.classList.remove('drawer--open');
    }, 500);
    document.activeElement.blur();
  }
}
customElements.define('main-drawer', MainDrawer);
class DetailsDrawer extends MainDrawer {
  constructor() {
    super();

    this.details = this.querySelector('details');
  }

  closeDrawer() {
    this.drawer.classList.remove('drawer--active');
    setTimeout(() => {
      document.body.classList.remove('drawer--open');
      this.details.removeAttribute('open');
    }, 500);
    document.activeElement.blur();
  }
}
customElements.define('details-drawer', DetailsDrawer);
class SearchDrawer extends MainDrawer {
  constructor() {
    super();

    this.setFocus = debounce((event) => {
      trapFocus(this, this.querySelector('.search-drawer'));
      document.getElementById('SearchInput').focus();
    }, 300);
    /*document.getElementById('SearchDrawerTrigger').addEventListener('click', (e) => {
      this.openDrawer();
      this.setFocus();
      if (!document.getElementById('PREDICTIVESEARCHCSS') && document.getElementById('PREDICTIVESEARCHJS')) {
        this.classList.add('loading');
      }
      if (this.querySelector('predictive-search')) {
        loadScript('predictive-search').catch((error) => {
          console.error(error);
        });
        loadCss('predictive-search')
          .then(() => {
            this.classList.remove('loading');
          })
          .catch((error) => {
            console.error(error);
          });
      }
    });*/

		/*
		*/
  }
}
customElements.define('search-drawer', SearchDrawer);
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.hide());
    this.querySelectorAll('.modal__close').forEach((el) => el.addEventListener('click', () => this.hide()));
    this.querySelector('.modal-trigger').addEventListener('click', this.show.bind(this));
  }

  hide() {
    this.querySelector('dialog').removeAttribute('open');
    this.querySelector('.modal').classList.remove('modal--active');
    document.body.classList.remove('modal--open');
    removeTrapFocus(this);
  }

  show() {
    this.querySelector('dialog').setAttribute('open', '');
    this.querySelector('.modal').classList.add('modal--active');
    document.body.classList.add('modal--open');
    trapFocus(this);
  }
}
customElements.define('modal-dialog', ModalDialog);
class SearchDialog extends ModalDialog {
  constructor() {
    super();

    this.querySelector('.modal-trigger').addEventListener('click', this.loadAssets.bind(this));
  }

  loadAssets() {
    this.show();
    setTimeout(() => {
      document.getElementById('SearchInput').focus();
    }, 500);
    if (!document.getElementById('PREDICTIVESEARCHCSS') && !document.getElementById('PREDICTIVESEARCHJS')) {
      this.classList.add('loading');
    }
    if (this.querySelector('predictive-search')) {
      loadScript('predictive-search').catch((error) => {
        console.error(error);
      });
      loadCss('predictive-search')
        .then(() => {
          this.classList.remove('loading');
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }
}
customElements.define('search-dialog', SearchDialog);
// Back to top
(function backToTop() {
  const trigger = document.querySelector('.btn--back-to-top');

  if (trigger) {
    const backToTopReveal = (e) => {
      if (window.pageYOffset >= 50) {
        trigger.classList.add('btn--back-to-top__revealed');
      } else {
        trigger.classList.remove('btn--back-to-top__revealed');
      }
    };

    backToTopReveal();
    window.addEventListener('scroll', backToTopReveal);

    trigger.addEventListener('click', (e) => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
})();

// Page transition
window.addEventListener('beforeunload', () => {
  document.body.classList.add('unloading');
});
window.addEventListener('DOMContentLoaded', () => {
  document.body.classList.add('loaded');
});
window.addEventListener('pageshow', (event) => {
  // Removes unload class when returning to page via history
  if (event.persisted) {
    document.body.classList.remove('unloading');
  }
});

const productFormObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        loadScript('product-form').catch((error) => {
          console.error(error);
        });
        productFormObserver.unobserve(entry.target);
      }
    });
  },
  { rootMargin: '0px 0px 250px 0px' }
);

document.querySelectorAll('[product-form-oberver]').forEach((el) => productFormObserver.observe(el));

const imageObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('loaded');
        imageObserver.unobserve(entry.target);
      }
    });
  },
  { threshold: 0.25 }
);

document.querySelectorAll('img[loading="lazy"]').forEach((el) => imageObserver.observe(el));

Array.from(document.getElementsByClassName('product-card')).forEach( productCard => {
	productCard.getElementsByClassName('product-card__btn')[0].addEventListener('click', e => {
		closeAllProductCardForms();
		productCard.classList.add('is-form-open');
	})
});

function closeAllProductCardForms() {
	Array.from(document.getElementsByClassName('product-card')).forEach( productCard => {
		productCard.classList.remove('is-form-open');
	});
}

/*
	**********************************
	START GSAP ANIMATIONS
	**********************************
*/

(() => {
		var e = document.querySelectorAll("[data-ac]");
		e.length && e.forEach((function(e) {
				var t = e.querySelectorAll("[data-ae]"),
						i = 60;
				void 0 !== e.dataset.acFade && (i = 0), t.length && gsap.fromTo(t, {
						y: i,
						opacity: 0
				}, {
						scrollTrigger: {
								trigger: e,
								start: "top 90%"
						},
						stagger: {
								each: .2,
								onComplete: function() {
										this._targets[0].classList.add("animation-finished")
								}
						},
						y: 0,
						opacity: 1,
						duration: 1.3,
						ease: "power3.out",
						force3D: !0
				})
		}));
	})();

(() => {
		var t = document.querySelectorAll("[data-st]");
		t.length && t.forEach((function(e) {
				var t = 0;
				void 0 !== e.dataset.delay && (t = +e.dataset.delay), void 0 !== e.dataset.fade ? gsap.fromTo(e, {
						y: 0,
						opacity: 0
				}, {
						scrollTrigger: {
								trigger: e,
								start: "top 90%"
						},
						stagger: .5,
						y: 0,
						opacity: 1,
						duration: 1.3,
						delay: t,
						ease: "power3.out"
				}) : gsap.fromTo(e, {
						y: 60,
						opacity: 0
				}, {
						scrollTrigger: {
								trigger: e,
								start: "top 90%"
						},
						stagger: .3,
						y: 0,
						opacity: 1,
						duration: 1.3,
						delay: t,
						ease: "power3.out"
				})
		}))
	})();

(() => {
	//gsap.registerPlugin(hs);
	var e = document.querySelectorAll("[data-fade-container]"),
			t = document.querySelector("[data-fade]"),
			i = document.querySelector("[data-fade-transformX]"),
			n = document.querySelector("[data-fade-transformY]"),
			r = document.querySelector("[data-fade-single]");
	t && e.length && e.forEach((function(e) {
			var t = e.querySelectorAll("[data-fade]");
			t.length && gsap.fromTo(t, {
					opacity: 0
			}, {
					scrollTrigger: {
							trigger: e,
							start: "top 80%"
					},
					stagger: {
							each: .2,
							onComplete: function() {
									this._targets[0].classList.add("animation-finished")
							}
					},
					opacity: 1,
					duration: 2.5,
					ease: "power2.out"
			})
	})), r && document.querySelectorAll("[data-fade-single]").forEach((function(e) {
			gsap.fromTo(e, {
					opacity: 0
			}, {
					scrollTrigger: {
							trigger: e,
							start: "top 80%"
					},
					opacity: 1,
					duration: 1,
					delay: .5,
					ease: "power2.out"
			})
	})), i && e.length && e.forEach((function(e) {
			var t = e.querySelectorAll("[data-fade-transformX]");
			t.length && (gsap.set(t, {
					xPercent: 60,
					opacity: 0
			}), gsap.timeline({
					scrollTrigger: {
							trigger: e,
							start: "top 99%"
					}
			}).to(t, {
					stagger: .05,
					xPercent: 0,
					opacity: 1,
					duration: 1,
					ease: "power3.out"
			}))
	})), n && e.length && e.forEach((function(e) {
			var t = e.querySelectorAll("[data-fade-transformY]");
			t.length && gsap.fromTo(t, {
					yPercent: 30,
					opacity: 0
			}, {
					scrollTrigger: {
							trigger: e,
							start: "top 80%"
					},
					stagger: {
							each: .1,
							onComplete: function() {
									this._targets[0].classList.add("animation-finished")
							}
					},
					yPercent: 0,
					opacity: 1,
					duration: 1.6,
					ease: "power3.out"
			})
	}))
})();

(() => {
	(l = document.querySelectorAll("[data-hero]")).length && l.forEach((function(e) {
		var t = e.querySelectorAll("[data-hero-el]"),
				i = e.querySelectorAll("[data-hero-el-reverse]"),
				n = e.querySelectorAll("[data-hero-image]"),
				r = e.querySelectorAll("[data-hero-fade]"),
				a = gsap.timeline({
						scrollTrigger: {
								trigger: e,
								start: "top 80%"
						}
				});
		n.length && a.fromTo(n, {
				scale: 1.1,
				opacity: 0,
				"clip-path": "polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)",
				"-webkit-clip-path": "polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)"
		}, {
				scale: 1,
				opacity: 1,
				duration: 1,
				"clip-path": "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
				"-webkit-clip-path": "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)"
		}), t.length && a.fromTo(t, {
				y: 60,
				opacity: 0
		}, {
				stagger: {
						each: .3,
						onComplete: function() {
								this._targets[0].classList.add("animation-finished")
						}
				},
				y: 0,
				opacity: 1,
				duration: 1.5,
				ease: "power3.out"
		}), i.length && a.fromTo(i, {
				y: -60,
				opacity: 0
		}, {
				stagger: {
						each: .3,
						onComplete: function() {
								this._targets[0].classList.add("animation-finished")
						}
				},
				y: 0,
				opacity: 1,
				duration: 1.5,
				ease: "power3.out"
		}), r && gsap.fromTo(r, {
				opacity: 0
		}, {
				scrollTrigger: {
						trigger: e,
						start: "top 90%"
				},
				stagger: {
						each: .3,
						onComplete: function() {
								this._targets[0].classList.add("animation-finished")
						}
				},
				opacity: 1,
				duration: 1.6,
				ease: "power3.out"
		})
	}))
})();

/*
	**********************************
	END GSAP ANIMATIONS
	**********************************
*/

/* start - header - show S instead of logo on scroll */
(() => {
	logoScroll();
	window.addEventListener('scroll', logoScroll);
	function logoScroll(){
		if(window.scrollY > 0) {
			document.getElementsByClassName('header')[0].classList.add('scrolled');
		} else {
			document.getElementsByClassName('header')[0].classList.remove('scrolled');
		}
	}
})();
/* end - header - show S instead of logo on scroll */

// On input click add is-active to the parent label element.
// This will shrink and move the label text
(() => {
	Array.from(document.getElementsByClassName('theme-input')).forEach( el => {
		let input = el.getElementsByTagName('input')[0];
		// On load, if input field are auto populated, add is active	

		// set to active on autofill
		setTimeout(()=>{
			let inputStyle = window.getComputedStyle(input);
			if(inputStyle.backgroundColor != 'rgb(255, 255, 255)' || input.value != '') {
				el.classList.add('is-active');
			}
		}, 1500)

		input.addEventListener('click', e => {
			el.classList.add('is-active');
			document.addEventListener('click', evt => {
				if(evt.target != e.target && input.value == ""){
					el.classList.remove('is-active');
				}
			})
		})

		input.addEventListener('input', e => {
			if(input.value != ""){
				el.classList.add('is-active');
			}
		})
	})
})();

// format yotpo review stars
(() => {
	(p = document.querySelectorAll("[data-rating-wrapper]")).length > 0 && setTimeout((function() {
		p.forEach((function(e) {
			console.log('e')
			console.log(e)
			var t = e.querySelector(".text-m");
			if (t) {
					var i = e.querySelector("[data-rating-quantity]"),
							n = t.innerHTML.split(" Review")[0];
					i.innerHTML = n
			}
		}))
	}), 5000)
})();

// status
(() => {
	const waitForStatus = setInterval(function() {      
		if (typeof StatusAccounts != "undefined") {
			if(StatusAccounts.customer.hasOwnProperty('firstName')){
				document.getElementsByClassName('status-header-link')[0].style.display = 'block';
				document.getElementsByClassName('status-header-link')[0].getElementsByTagName('span')[0].innerHTML = StatusAccounts.customer.firstName + "'s ";
				document.getElementsByClassName('mmenu__status')[0].style.display = 'block';
				document.getElementsByClassName('mmenu__status')[0].getElementsByTagName('span')[0].innerHTML = StatusAccounts.customer.firstName + "'s ";
			} else {
				const waitForStatusFirstName = setInterval(function() {
					if(StatusAccounts.customer.hasOwnProperty('firstName')){
						document.getElementsByClassName('status-header-link')[0].style.display = 'block';
						document.getElementsByClassName('status-header-link')[0].getElementsByTagName('span')[0].innerHTML = StatusAccounts.customer.firstName + "'s "; 
						document.getElementsByClassName('mmenu__status')[0].style.display = 'block';
						document.getElementsByClassName('mmenu__status')[0].getElementsByTagName('span')[0].innerHTML = StatusAccounts.customer.firstName + "'s ";
						clearInterval(waitForStatusFirstName);
					}
				}, 2000);
			}
			clearInterval(waitForStatus);      
		}
	}, 1000);  
})(); 

Array.from(document.getElementsByTagName('form')).forEach( form => {
  if(form.classList.contains('product-size')){
    let atcWrap = form.getElementsByClassName('js-product-main-btns')[0];
    if(form.getElementsByClassName('inventory-alert').length > 0){
      form.getElementsByClassName('inventory-alert')[0].remove();
    }
    let inventoryQuantity;
    Array.from(form.getElementsByTagName('select')[0].getElementsByTagName('option')).forEach(
      option => {
        if(option.hasAttribute('selected')){
          inventoryQuantity = option.dataset.quantity;
          //console.log(option.dataset.quantity)
        }
      }
    )
    //console.log('inventoryQuantity')
    //console.log(inventoryQuantity)
    //if(inventoryQuantity < 6 && inventoryQuantity > 0) {
      //atcWrap.insertAdjacentHTML('beforebegin', `<div class="inventory-alert">Only ${inventoryQuantity} left</div>`)
      //setTimeout(()=>{
        //form.getElementsByClassName('inventory-alert')[0].classList.add('show'); //uncomment to enable this feature
      //}, 100)
    //}
  }
})

function dropdownInventoryQuantityAlert(){
  Array.from(document.getElementsByTagName('form')).forEach( form => {
    if(form.getElementsByClassName('js-active-now').length > 0){
      let inventoryQuantity;
      Array.from(document.getElementsByClassName('js-active-now')[0].getElementsByTagName('option')).forEach(option => {
        if(option.hasAttribute('selected')){
          //console.log('option')
          //console.log(option)
          inventoryQuantity = option.dataset.quantity
        }
      })

      if(form.getElementsByClassName('inventory-alert').length > 0){
        form.getElementsByClassName('inventory-alert')[0].remove();
      }
      if(inventoryQuantity < 6 && inventoryQuantity > 0) {
        let atcWrap = form.getElementsByClassName('js-product-main-btns')[0];
        //atcWrap.insertAdjacentHTML('beforebegin', `<div class="inventory-alert">Only ${inventoryQuantity} left</div>`)
        //setTimeout(()=>{
          //form.getElementsByClassName('inventory-alert')[0].classList.add('show');
        //}, 100)
      }
    }
  })
}

dropdownInventoryQuantityAlert();

setTimeout(() => {
  Array.from(document.getElementsByClassName('custom-select__item')).forEach( el => {
    el.addEventListener('click', () => {
      //console.log('click')
      dropdownInventoryQuantityAlert();
    })
  })
}, 2000)

/* Begin hotfix for Nosto Quick add to cart buttons */
/* Currently Nosto ATC buttons don't open the side when a product is added */
function nostoATCAddListeners(){
  //console.log('nostoATCAddListeners')
  //console.log(Array.from(document.getElementsByClassName('ns-button')))
  Array.from(document.getElementsByClassName('ns-button')).forEach(
    btn => {
      let type = 'add';
      if(btn.innerText == 'Select Size'){
        type = 'select'
      }
      let parent = btn.parentNode.parentNode;
      btn.addEventListener('click', btn => {nostoClickHandler(type, parent)});
    }
  )
}
function nostoClickHandler(type, parent){
  //console.log(' click nostoAddToCart')
  //console.log(type)
  if(type == 'select'){
    //console.log('parentNode')
    //console.log(parent)
    setTimeout(()=>{
      parent.getElementsByClassName('ns-button')[0].addEventListener('click',()=>{
        openCartOnATC();
      })
    }, 250)
    return;
  }
  openCartOnATC();
}

function openCartOnATC(){
  setTimeout(()=>{
    fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => {
      return response.json();
    })
    .then(response =>{
      let formData = {
      // 'updates': {},
      'note': response.note,
      'sections': "cart-drawer,cart-icon-bubble" 
      };

      //formData.updates[response.items[0].variant_id] = response.items[0].quantity;

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        return response.json();
      })
      .then(response =>{
        const cartDrawer = document.querySelector('cart-drawer');
        cartDrawer.renderContents(response);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }, 250)
}

setTimeout(()=>{
  nostoATCAddListeners();
}, 5500)